module.exports = ".card-header{\r\n    padding: .25rem 0.25rem;\r\n}"